import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import dayjs from 'dayjs';
import { getMinTimezone } from 'chameleon-src/utility/utils';
import WrappedDatePicker from './WrappedDataPicker';

/**
 * Wrapper for assessment begins and assessment due dates.
 * */
const DateField = (props) => {
  const {
    isAssign,
    hasMinDate,
    minDate,
    maxDate,
    openToDate,
    sections,
    defaultTimezone,
    isNewModal,
    ...otherProps
  } = props;
  const fieldProps = { ...otherProps };
  const [timezone, setTimezone] = useState(null);

  /**
   * Use effect for updating the western timezone when sections list is changed.
   * Note: This applies only for assigning form, not for manage assignment form.
   * */
  useEffect(() => {
    const sectionTimezones = sections.map((section) => section.timezone);
    const minTimezone = getMinTimezone(sectionTimezones);
    setTimezone(minTimezone || defaultTimezone);
  }, [sections, defaultTimezone]);

  if (!timezone) {
    return null;
  }

  if (hasMinDate) {
    let dateFieldMinDate = dayjs().tz(timezone);
    const minDateIsInTheFuture = dateFieldMinDate.diff(minDate, 'second') < 0;
    if (minDateIsInTheFuture) {
      dateFieldMinDate = minDate;
    }
    fieldProps.minDate = dateFieldMinDate;
  }

  if (maxDate) {
    fieldProps.maxDate = maxDate;
  }

  if (openToDate) {
    fieldProps.openToDate = openToDate;
  }

  return (
    <Field
      component={WrappedDatePicker}
      {...fieldProps}
      timezone={timezone}
      isNewModal={isNewModal}
      isAssign={isAssign}
    />
  );
};

DateField.displayName = 'DateField';

DateField.props = {
  // Flag for setting a min date.
  hasMinDate: PropTypes.bool,
  // Min date to set if the flag is true.
  minDate: PropTypes.object,
  // Max date to set.
  maxDate: PropTypes.object,
  // Open the calendar to specific date.
  openToDate: PropTypes.object,
  // If we want to show the "todayButton"
  hideTodayButton: PropTypes.bool,
};

DateField.defaultProps = {
  hasMinDate: false,
  minDate: null,
  maxDate: null,
  openToDate: null,
  hideTodayButton: false,
};

export default DateField;
